<template>
  <div class="content">
    <form class="form-horizontal" @submit.prevent="onSubmit">
      <card class="text-left">
        <template slot="header">
          <h4 class="card-title">스케줄 타입 작성</h4>
        </template>
        <div class="row">
          <label class="col-sm-2 col-form-label">알림 아이콘 타입</label>
          <div class="col-sm-10 checkbox-radios">
            <span v-for="(n, index) in scheduleTypes" :key="index">
              <base-radio :name="n.id.toString()" inline v-model="type">{{ n.name }}</base-radio>
            </span>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">알림명</label>
          <div class="col-sm-4">
            <base-input placeholder="알림명" v-model="name">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>

        <hr />
        <div class="row">
          <label class="col-sm-2 col-form-label">타이틀 선택</label>
          <div class="col-sm-4">
            <el-select class="select-primary" size="large" placeholder="" v-model="titleSelect" @change="changeTitle">
              <el-option v-for="option in titleOptions" class="select-primary" :value="option.value" :label="option.label" :key="option.label"></el-option>
            </el-select>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-2"></div>
          <div class="col-sm-10">
            <div class="row">
              <div class="col-sm-2">언어</div>
              <div class="col-sm-4">푸시 알림 타이틀</div>
              <div class="col-sm-4">푸시 알림 내용</div>
            </div>
          </div>
        </div>
        <br />
        <div class="row">
          <label class="col-sm-2 col-form-label">푸시 알림 내용</label>
          <div class="col-sm-10">
            <div class="row">
              <div class="col-sm-2 text-center">ko</div>
              <div class="col-sm-4 text-center">
                <base-input placeholder="타이틀" v-model="title">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
              <div class="col-sm-4 text-center">
                <base-input placeholder="내용" v-model="body">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-2 text-center">en</div>
              <div class="col-sm-4 text-center">
                <base-input placeholder="타이틀" v-model="title_en">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
              <div class="col-sm-4 text-center">
                <base-input placeholder="내용" v-model="body_en">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-2 text-center">ja</div>
              <div class="col-sm-4 text-center">
                <base-input placeholder="타이틀" v-model="title_ja">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
              <div class="col-sm-4 text-center">
                <base-input placeholder="내용" v-model="body_ja">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
            </div>
          </div>
        </div>

        <hr />
        <div class="row">
          <label class="col-sm-2 col-form-label">파이어베이스 분석용 라벨</label>
          <div class="col-sm-4">
            <base-input placeholder="라벨" v-model="analyticsLabel">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">알림시간</label>
          <div class="col-sm-4">
            <el-select class="select-primary" size="large" placeholder="위치" v-model="timeStandard">
              <el-option v-for="option in timeOptions" class="select-primary" :value="option.value" :label="option.label" :key="option.label"></el-option>
            </el-select>
          </div>
          <div class="col-sm-2">
            <base-input placeholder="시간(분)" v-model="timeInterval">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          분
          <el-popover trigger="hover" placement="top">
            <div>
              <div class="popover-body">0: 정시, 10: 10분후, -60: 60분전</div>
            </div>
            <base-button slot="reference"> ? </base-button>
          </el-popover>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">테스터타입</label>
          <div class="col-sm-4">
            <el-select class="select-primary" size="large" placeholder="타입" v-model="testerType">
              <el-option v-for="option in testerTypes" class="select-primary" :value="option.value" :label="option.label" :key="option.label"></el-option>
            </el-select>
          </div>
        </div>
      </card>
      <base-button native-type="submit" type="success">등록</base-button>
      <base-button @click="goBack" type="default">취소</base-button>
    </form>
  </div>
</template>
<script>
import { BaseInput, Card } from "@/components/index";
import * as _ from "lodash";
export default {
  components: {
    Card,
    BaseInput,
  },
  async created() {
    if (this.$route.query.id) {
      this.id = Number(this.$route.query.id);
      await this.getNotificationType();
    }
    await this.getScheduleTypes();
  },
  data() {
    return {
      title: "[{{unitName}}] {{scheduleName}}",
      body: null,
      title_en: "[{{unitName}}] {{scheduleName}}",
      body_en: null,
      title_ja: "[{{unitName}}] {{scheduleName}}",
      body_ja: null,
      scheduleTypes: [],
      type: 1,
      analyticsLabel: null,
      category: 1,
      description: null,
      iconUrl: null,
      name: null,
      timeInterval: null,
      timeStandard: 1,
      isVisible: true,
      titleSelect: "[{{unitName}}] {{scheduleName}}",
      titleOptions: [
        { label: "직접작성", value: null },
        { label: "[아티스트명] 스케줄명", value: "[{{unitName}}] {{scheduleName}}" },
      ],
      timeOptions: [
        { label: "시작시간기준", value: 1 },
        { label: "종료시간기준", value: 2 },
      ],
      testerType: null,
      testerTypes: [
        { label: "전체", value: null },
        { label: "A", value: 0 },
        { label: "B", value: 1 },
      ],
    };
  },
  methods: {
    changeTitle() {
      this.title = this.titleSelect;
      this.title_en = this.titleSelect;
      this.title_ja = this.titleSelect;
    },
    async getScheduleTypes() {
      return this.$axios.get("/schedule/scheduleTypes").then((res) => {
        this.scheduleTypes = res.data.data;
      });
    },
    async getNotificationType() {
      return this.$axios.get(`/schedule/scheduleNotificationTypes/${this.id}`).then((res) => {
        const data = res.data.data;
        if (data) {
          this.analyticsLabel = data.analyticsLabel;
          this.body = data.body;
          this.category = data.category;
          this.description = data.description;
          this.iconUrl = data.iconUrl;
          this.name = data.name;
          this.timeInterval = data.timeInterval;
          this.timeStandard = data.timeStandard;
          this.type = data.type;
          this.testerType = data.testerType;
          this.title = data.title;
          this.isVisible = data.isVisible === 1;
          const template = JSON.parse(data.template);
          const en = _.find(template, { lang: "en" });
          if (en) {
            this.title_en = en.title;
            this.body_en = en.body;
          }
          const ja = _.find(template, { lang: "ja" });
          if (ja) {
            this.title_ja = ja.title;
            this.body_ja = ja.body;
          }
        }
      });
    },

    async onSubmit() {
      const param = {
        name: this.name,
        type: this.type,
        title: this.title,
        body: this.body,
        template: JSON.stringify([
          {
            lang: "ko",
            title: this.title,
            body: this.body,
          },
          {
            lang: "en",
            title: this.title_en,
            body: this.body_en,
          },
          {
            lang: "ja",
            title: this.title_ja,
            body: this.body_ja,
          },
        ]),
        category: this.category,
        iconUrl: this.iconUrl,
        timeInterval: this.timeInterval,
        timeStandard: this.timeStandard,
        testerType: this.testerType,
        description: this.description,
        analyticsLabel: this.analyticsLabel,
        isVisible: this.isVisible ? 1 : 0,
      };

      if (!this.name) {
        Toast.error("알림명을 입력해주세요");
        return;
      }
      if (!this.type) {
        Toast.error("아이콘타입을 선택해주세요");
        return;
      }
      if (!this.title || !this.title_en || !this.title_ja) {
        Toast.error("타이틀을 언어별로 입력해주세요");
        return;
      }
      if (_.isNil(this.timeInterval)) {
        Toast.error("알림 시간을 설정해주세요");
        return;
      }

      if (this.id) {
        return this.$axios.put(`/schedule/scheduleNotificationTypes/${this.id}`, param).then((res) => {
          Toast.success("등록되었습니다");
          this.$router.go(-1);
        });
      } else {
        return this.$axios.post(`/schedule/scheduleNotificationTypes`, param).then((res) => {
          Toast.success("등록되었습니다");
          this.$router.go(-1);
        });
      }
    },
    goBack() {
      history.go(-1);
    },
  },
};
</script>
<style scoped lang="scss">
.bootstrap-switch {
  margin: 6px;
}
</style>
